import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import * as firebase from 'firebase'
import store from './store.js'
import CKEditor from '@ckeditor/ckeditor5-vue'
const configOptions = {
  apiKey: 'AIzaSyCHB3q8ICvVTyaPLOA4eXkfngX8OG5dT40',
  authDomain: 'kpss-genel-app.web.app',
  databaseURL: 'https://kpss-genel-app.firebaseio.com/',
  projectId: 'kpss-genel-app',
  storageBucket: 'gs://kpss-genel-app.appspot.com',
  messagingSenderId: '',
  appId: 'kpss-genel-app'
}

firebase.initializeApp(configOptions)
firebase.auth().onAuthStateChanged(user => {
  store.dispatch('fetchUser', user)

  if (router.currentRoute.value.name !== 'Login' && !user) {
    router.push('/login')
  }
})
createApp(App).use(router).use(store).use(CKEditor).mixin(
  {
    methods: {

      findContent: function (contents, page) {
        return contents.filter((v, i) => { return i >= (page - 1) * process.env.VUE_APP_ENV_PER_PAGE && i < page * process.env.VUE_APP_ENV_PER_PAGE })
      },
      searchContent: function (contents, search, where) {
        return contents.filter((v) => { return v[where].toLocaleLowerCase().includes(search.toLocaleLowerCase()) })
      },
      makeArray: function (data) {
        const arr = []
        if (data) {
          Object.keys(data).map((v, k) => {
            arr.push({ firebaseKey: v, ...data[v] })
          })
        }
        return arr
      }
    }
  }
).mount('#app')
